import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "toggleButton"]
  static values = { max: Number }

  connect() {
    this.showingAll = false
    this.update()
  }

  toggle() {
    this.showingAll = !this.showingAll
    this.update()
  }

  update() {
    const showAll = this.showingAll
    this.itemTargets.forEach((el, index) => {
      el.classList.toggle("tw-hidden", !showAll && index >= this.maxValue)
    })

    this.toggleButtonTarget.textContent = showAll ? "View less" : "View more"
  }
}
